import React from "react";
import { NavLink } from "react-router-dom";
import { CheckAuthPolicy } from "HOC/WithPermissions/WithPermissions";
import {mergeShortUrl} from "modules/App/state/actions";
import {useDispatch} from "react-redux";
import "./MenuItem.scss";

const HeaderMenuItem = ({ path, name, permission }) => {
    const dispatch = useDispatch();
    if(permission) {
        return (
            <CheckAuthPolicy predicate={permission}>
                <NavLink
                    className="menu-item__link"
                    to={path}
                    activeClassName="active"
                    onClick={() => {
                        dispatch(mergeShortUrl({"id": null, "body": null}));
                    }}
                >
                    {name}
                </NavLink>
            </CheckAuthPolicy>
        );
    }

    return (
        <NavLink
            className={"menu-item__link"}
            to={path}
            activeClassName={"active"}
            onClick={() => {
                dispatch(mergeShortUrl({"id": null, "body": null}));
            }}
        >
            {name}
        </NavLink>
    );
};

export default HeaderMenuItem;
